import { useState } from 'react';
import { trackBlogFeedback } from '@/lib/utils/analytics';

function alreadyVoted(slug: string): boolean {
    try {
        return window.localStorage.getItem(`msf_blog_feedback_${slug}`) !== null;
    } catch {
        return false;
    }
}

function rememberVote(slug: string, helpful: boolean): void {
    try {
        window.localStorage.setItem(`msf_blog_feedback_${slug}`, helpful ? 'yes' : 'no');
    } catch {
        /* noop — feedback still fires, just not deduped on repeat visits */
    }
}

/** One-question "was this helpful?" widget — fires a PostHog event only, no backend/Firestore write. */
export default function BlogFeedback({ slug }: { slug: string }) {
    const [voted, setVoted] = useState(() => (typeof window !== 'undefined' ? alreadyVoted(slug) : false));

    if (voted) {
        return (
            <div className="not-prose my-10 rounded-lg border border-gray-200 bg-gray-50 p-5 text-sm text-gray-600">
                Thanks for the feedback — it helps us write more of what's actually useful.
            </div>
        );
    }

    const vote = (helpful: boolean) => {
        trackBlogFeedback(slug, helpful);
        rememberVote(slug, helpful);
        setVoted(true);
    };

    return (
        <div className="not-prose my-10 rounded-lg border border-gray-200 bg-gray-50 p-5">
            <p className="text-sm font-semibold text-gray-900 mb-3">Was this article helpful?</p>
            <div className="flex gap-3">
                <button
                    type="button"
                    onClick={() => vote(true)}
                    className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:border-primary hover:text-primary transition-colors"
                >
                    👍 Yes
                </button>
                <button
                    type="button"
                    onClick={() => vote(false)}
                    className="rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:border-primary hover:text-primary transition-colors"
                >
                    👎 Not really
                </button>
            </div>
        </div>
    );
}
